import { Directive, Input, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, Validators, AbstractControl, ValidatorFn } from '@angular/forms';

import { CovalentValidators } from '../validators';

export const /** @type {?} */ MAX_VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => TdMaxValidator),
  multi: true,
};
export class TdMaxValidator implements Validator {
private _validator: ValidatorFn;
/**
 * @param {?} max
 * @return {?}
 */
set max(max: number) {
    this._validator = CovalentValidators.max(max);
  }
/**
 * @param {?} c
 * @return {?}
 */
validate(c: AbstractControl): {[key: string]: any} {
    return this._validator(c);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[max][formControlName],[max][formControl],[max][ngModel]',
  providers: [ MAX_VALIDATOR ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'max': [{ type: Input, args: ['max', ] },],
};
}

function TdMaxValidator_tsickle_Closure_declarations() {
/** @type {?} */
TdMaxValidator.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdMaxValidator.ctorParameters;
/** @type {?} */
TdMaxValidator.propDecorators;
/** @type {?} */
TdMaxValidator.prototype._validator;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
